import { getRecorderEmails } from '@/constants';
import { getValueFromLocalstore } from '@/services/localStorage.service';
import loggerService from '@/services/logger.service';

export function getUseGCAuth(): boolean {
  const traits = getValueFromLocalstore('ajs_user_traits');
  if (traits?.email && getRecorderEmails().includes(traits.email)) {
    loggerService.info('Recorder email detected, returning false for useGCAuth', traits.email);
    return false;
  }

  return true;
}
